import React from "react";
import {styled} from "@reside/ui";
import {Tooltip} from "../../../tooltip";
import {getWorkflowStyle} from "../../../dashboard-cell/WorkflowRibbon";

// TODO DEV-4072: Inline SVGs are a workaround until the ticket is resolved and proper icons are available via @reside/ui
const WorkflowTriggerLinkIcon = ({color}: {color: string}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{color}}
    data-test-id="triggeredWorkflowIcon"
  >
    <path d="M9 17H7A5 5 0 0 1 7 7h2" />
    <path d="M15 7h2a5 5 0 1 1 0 10h-2" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

type Props = {
  workflowType?: string;
};

export const TriggeredWorkflowIcon = ({workflowType}: Props) => {
  const {color} = getWorkflowStyle(workflowType);

  return (
    <StyledTooltip content="Automatically created by a workflow trigger.">
      <WorkflowTriggerLinkIcon color={color} />
    </StyledTooltip>
  );
};

const StyledTooltip = styled(Tooltip)`
  cursor: default;
`;
